import { View } from 'backbone';
import { Model } from 'backbone';
import template  from 'dashboard/settings/select-all-instances-modal-view.ejs';


class SelectAllInstancesModal extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#selectAllInstances";

        if (this.options) {
            this.width = this.options.width;
            this.height = this.options.height;
        }

        this.model.set("toSelect", 'page');

        return this;
    }

    closeModal() {
        $(this.El).remove();
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set(propName, propVal, {silent:true});
       
    }

    bindEvents() {
        $('input[type=radio][name=toSelect]').on('change',(e)=>{
            this.updateRadioAttributes(e);
        });
    }

    selectInstances(){
        return this.model.get("toSelect");
    }

    unbindEvents() {
        $('input[type=radio][name=toSelect]').off('change');
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            const self = this;

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: this.height || 500,
                width: this.width || 520,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {                            
                            this.dialog.dialog( "close" );
                            resolve(self.selectInstances());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            resolve("canceled");
                        }
                    }
                ],
                close: () => {
                    self.unbindEvents();
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                     self.bindEvents();
                  }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            $('button.btn-select-field').button({disabled: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default SelectAllInstancesModal;